import { render, staticRenderFns } from "./map2.vue?vue&type=template&id=12a0b617&scoped=true&"
import script from "./map2.vue?vue&type=script&lang=js&"
export * from "./map2.vue?vue&type=script&lang=js&"
import style0 from "./map2.vue?vue&type=style&index=0&id=12a0b617&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0b617",
  null
  
)

export default component.exports